<template>
  <div id="wxshare"></div>
</template>

<script>
import wx from 'weixin-js-sdk';
import $ from 'jquery';
export default {
  name: 'WxShare',
  props: {
    shareTitle: String,
    shareDesc: String,
    shareImg: String,
    shareLink: String,
  },
  mounted() {
    this.sharethis();
  },
  methods: {
    sharethis() {
      const _this = this;
      // const server = 'http://it.mn.sina.com/public/weixin/shara_jssdk/jsoncall.php?callback=?&rnd="+Math.random()';
      const server = "https://www.appmn.cn/public/weixin/shara_jssdk/jsoncall.php?callback=?&rnd="+Math.random();
      // const server = "http://common.mn.sina.com.cn/public/activity/weixin/shara_jssdk/jsoncall.php?rnd="+Math.random();
      // const server = "http://it.mn.sina.com/public/weixin/shara_jssdk/jsoncall.php?callback=?&rnd="+Math.random();
      // const server = "https://www.jinping.shop/public/weixin/shara_jssdk_jp/jsoncall.php?callback=?&rnd="+Math.random();   
      const currenturl = window.location.href;
      const postData = { url: currenturl };
      $.ajax({
        type: 'POST',
        url: server,
        data: postData,
        async: true,
        dataType: 'json',
        success(result) {
          // 分享功能 s
          wx.config({
            debug: false,
            appId: result.appId,
            timestamp: result.timestamp,
            nonceStr: result.nonceStr,
            signature: result.signature,
            jsApiList: [
              'checkJsApi',
              'onMenuShareTimeline',
              'onMenuShareAppMessage',
              'onMenuShareQQ',
              'onMenuShareWeibo',
            ],
          });
          _this.wechatReady();
        },
        error() {
          // window.alert("系统错误，请稍后再试");
        },
      });
    },
    wechatReady() {
      const _this = this;
      wx.ready(() => {
        const appMessageShareData = {
          title: _this.shareTitle,
          desc: _this.shareDesc,
          link: _this.shareLink,
          imgUrl: _this.shareImg,
        };
        wx.onMenuShareAppMessage(appMessageShareData);
        wx.onMenuShareTimeline(appMessageShareData);
        wx.onMenuShareQQ(appMessageShareData);
        wx.onMenuShareWeibo(appMessageShareData);
      });
      wx.error((res) => {
        // alert(res.errMsg);
      });
    },
  },
};
</script>